import React from "react";
import {
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBContainer,
    MDBSelect, MDBTableHead, MDBTable, MDBTableBody, MDBIcon
} from "mdbreact";
import firebase from "../../../firebase";

class PreviewOrg extends React.Component {
    constructor(props) {
        const dt = new Date();
        super(props);
        this.state = {
            id: null,
            companyid: null,
            orgData: {},
            companyData: {},
            users: [],
            sellerData: {},
            buyers: [],
            sellers: [],
        }
    }

    componentDidMount() {
        this.setOrgData();
    }

    setOrgData = async () => {
        let organizationRef =  this.props.db.collection('organizations').doc(this.props.id);
        let getDoc = organizationRef.get()
            .then(doc => {
                if (!doc.exists) {
                    console.log('No such organization document!')
                } else {
                    if ( doc.data().active ) {
                        let data = {};
                        data = doc.data();
                        data.id = doc.id;
                        data && data.sellers && this.setupSellersData(data.sellers);
                        data && data.buyers && this.setupBuyersData(data.buyers);
                        data && data.users &&  this.setupUsersData(data.users);
                        this.setupCompanyData(data.company);
                        data && data.seller && this.setupSellerData(data.seller);


                        this.setState({
                            orgData: data,
                            id : data.id
                        })
                    }
                }
            })
            .catch(err => {
                console.log('Error getting organization document', err)
            })
    }
    setupUsersData = async (e) => {
        //console.log('e',e)
        if (e && this.state.users.length === 0 ){
            let userList = await Promise.all(e.map(async d=> {
                let userRef = await this.props.db.collection('users').doc(d.user).get().catch(err => {
                    console.log('Error getting user ',  d.user,err)
                });
                let userData = userRef.data() || {};
                let email =  await firebase.functions().httpsCallable('getUserEmail')({uid: d.user}).catch(err => {
                    console.log('Error getting user mail',  d.user,err)
                });
                userData.id = userRef.id;
                userData.email = email ? email.data : '';

                return userData
            }))
         this.setState({
                users: userList,
            })
          // this.setupUsersData();
            }
    }
    setupCompanyData = (id) => {
        if ( id && id != this.state.companyid ){
            let companyRef = this.props.db.collection('company').doc(id);
            let getDoc = companyRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such company document!')
                    } else {
                        if ( doc.data().active ) {
                            let data = {};
                            data = doc.data();
                            data.id = doc.id;
                            this.setState({
                                companyData: data,
                                companyid: data.id,
                            })
                           // this.setupCompanyData();
                        }
                    }
                })
                .catch(err => {
                    console.log('Error getting company document', err)
                })
        }
    }
    setupSellerData = (id) => {
        let orgRef = this.props.db.collection('organizations').doc(id);
        let getDoc = orgRef.get()
            .then(doc => {
                if (!doc.exists) {
                    console.log('No such org document!')
                } else {
                    let data = {};
                    data.id = doc.id;
                    data.name = doc.data()['name'];
                    data.company_name = doc.data()['company_name'];
                    this.setState({
                        sellerData: data,
                    })
                }
            })
            .catch(err => {
                console.log('Error getting company document', err)
            })
    }
    setupBuyersData = (data) => {
        if(data && this.state.buyers.length === 0 ) {
            let buyers = [];
            data.map((e) => {
                if(e.organization) {
                    let orgRef = this.props.db.collection('organizations').doc(e.organization);
                    let getDoc = orgRef.get()
                        .then(doc => {
                            if (!doc.exists) {
                                console.log('No such org document!')
                            } else {
                                let data = {};
                                data.id = doc.id;
                                data.name = doc.data()['name'];
                                data.company_name = doc.data()['company_name'];
                                buyers.push(data);
                            }
                        })
                        .catch(err => {
                            console.log('Error getting company document', err)
                        })
                }

            })
            this.setState({
                buyers: buyers,
            })
        }
    }
    setupSellersData = (d) => {
        if(d && this.state.sellers.length === 0 ) {
            let sellers = [];
            d.map((e) => {
                let orgRef = this.props.db.collection('organizations').doc(e.organization);
                let getDoc = orgRef.get()
                    .then(doc => {
                        if (!doc.exists) {
                            console.log('No such org document!')
                        } else {
                            let data = {};
                            data.id = doc.id;
                            data.name = doc.data()['name'];
                            data.company_name = doc.data()['company_name'];
                            sellers.push(data);

                        }
                    })
                    .catch(err => {
                        console.log('Error getting company document', err)
                    })
            })
            this.setState({
                sellers: sellers,
            })
        }
    }
    render() {
        return (
            <>
                {
                    this.props.user && this.props.user.admin &&
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol md="12" className="mb-3">
                                <h2>事業所詳細（{this.state.orgData.buyer ? '購入U' : (this.state.orgData.reseller ? '販社U' : this.state.orgData && 'メーカーU')}）</h2>
                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#2E75B6', color: 'white'
                                }}>企業情報
                                </div>
                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#EEEEEE', color: '#212529', marginTop: 10
                                }}>本社
                                </div>
                                <form>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>企業ID</label>
                                        <label style={{flex: 1}}>{this.state.companyData.id}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>会社名</label>
                                        <label style={{flex: 1}}>{this.state.companyData.name}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>会社名かな</label>
                                        <label style={{flex: 1}}>{this.state.companyData.kana}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>郵便番号</label>
                                        <label style={{flex: 1}}>{this.state.companyData.zipcode}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>住所</label>
                                        <label style={{flex: 1}}>{this.state.companyData.address}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>TEL</label>
                                        <label style={{flex: 1}}>{this.state.companyData.TEL}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>FAX</label>
                                        <label style={{flex: 1}}>{this.state.companyData.FAX}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>法人番号</label>
                                        <label style={{flex: 1}}>{this.state.companyData['法人番号']}</label>
                                    </div>
                                </form>
                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#EEEEEE', color: '#212529', marginTop: 10
                                }}>事業所
                                </div>
                                <form>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>事業所ID</label>
                                        <label style={{flex: 1}}>{this.state.orgData.id}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>事業所名</label>
                                        <label style={{flex: 1}}>{this.state.orgData.name}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>事業所かな</label>
                                        <label style={{flex: 1}}>{this.state.orgData.kana}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>郵便番号</label>
                                        <label style={{flex: 1}}>{this.state.orgData.zipcode}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>住所</label>
                                        <label style={{flex: 1}}>{this.state.orgData.address}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>TEL</label>
                                        <label style={{flex: 1}}>{this.state.orgData.TEL}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>FAX</label>
                                        <label style={{flex: 1}}>{this.state.orgData.FAX}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>支払方法</label>
                                        <label style={{flex: 1}}>{this.state.orgData.paymentMethod || ''}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>支払日</label>
                                        <label
                                            style={{flex: 1}}>{this.state.orgData['paymentCheck'] && this.state.orgData['paymentDate'] ? this.state.orgData['paymentCheck'] + this.state.orgData['paymentDate'] + '日' : ''}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>締日</label>
                                        <label
                                            style={{flex: 1}}>{(this.state.orgData['closingDate'] === 31 ? '月末' : this.state.orgData['closingDate'] || '' + '日')}</label>
                                    </div>
                                </form>
                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#2E75B6', color: 'white', marginBottom: 10
                                }}>ユーザー情報
                                </div>
                                <MDBTable responsive small>
                                    <MDBTableHead style={{backgroundColor: '#EEEEEE'}}>
                                        <tr style={{color: '#212529'}}>
                                            <th style={{paddingLeft: '10px'}}>氏名</th>
                                            <th>UID</th>
                                            <th style={{textAlign: 'left'}}>メールアドレス</th>
                                            <th style={{textAlign: 'left'}}>電話番号</th>
                                            <th colSpan={2} style={{textAlign: 'left'}}>状態</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {
                                            this.state.users.map((user) => (
                                                <tr key={user.id} style={{width: '100%'}}>
                                                    <td style={{paddingLeft: '10px'}}>
                                                        <a>{user.first_name + ' ' + user.last_name}</a>
                                                    </td>
                                                    <td>
                                                        <a>{user.id}</a>
                                                    </td>
                                                    <td>
                                                        <a>{user.email}</a>
                                                    </td>
                                                    <td>
                                                        <a>{user['電話番号'] || ''}</a>
                                                    </td>
                                                    <td>
                                                        <a>{user.active ? '有効' : 'inActive'}</a>
                                                    </td>
                                                    <td>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-end',
                                                                alignItems: 'center',
                                                                position: 'relative'
                                                            }}>
                                                            <div className={'menuButton'} onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}>
                                                                <MDBIcon icon={'ellipsis-v'}/>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </MDBTableBody>
                                </MDBTable>
                                {
                                    this.state.orgData.buyer === true &&
                                    <div>
                                        <div style={{
                                            height: 30,
                                            justifyContent: 'flex-start',
                                            padding: 5,
                                            paddingLeft: 10,
                                            alignItems: "center",
                                            backgroundColor: '#2E75B6',
                                            color: 'white',
                                            marginBottom: 10
                                        }}>相手先情報
                                        </div>
                                        <MDBTable responsive small>
                                            <MDBTableHead style={{backgroundColor: '#EEEEEE'}}>
                                                <tr style={{color: '#212529'}}>
                                                    <th style={{paddingLeft: '10px'}}>U種別</th>
                                                    <th>事業所ID</th>
                                                    <th style={{textAlign: 'left'}}>会社名</th>
                                                    <th style={{textAlign: 'left', paddingRight: '60px'}}>事業所名</th>
                                                </tr>
                                            </MDBTableHead>
                                            <MDBTableBody>
                                                <tr>
                                                    <td style={{paddingLeft: '10px'}}>
                                                        <a>販社U</a>
                                                    </td>
                                                    <td>
                                                        <a>{this.state.orgData.seller || ''}</a>
                                                    </td>
                                                    <td>
                                                        <a>{this.state.sellerData.company_name || ''}</a>
                                                    </td>
                                                    <td>
                                                        <a>{this.state.sellerData.name || ''}</a>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                        </MDBTable>
                                    </div>
                                }
                                {
                                    (this.state.orgData.reseller || this.state.orgData.maker) &&
                                    <div>
                                        <div style={{
                                            height: 30,
                                            justifyContent: 'flex-start',
                                            padding: 5,
                                            paddingLeft: 10,
                                            alignItems: "center",
                                            backgroundColor: '#2E75B6',
                                            color: 'white',
                                            marginBottom: 10
                                        }}>相手先情報
                                        </div>
                                        <MDBTable responsive small>
                                            <MDBTableHead style={{backgroundColor: '#EEEEEE'}}>
                                                <tr style={{color: '#212529'}}>
                                                    <th colSpan={2} style={{paddingLeft: '10px'}}>購入U</th>
                                                </tr>
                                            </MDBTableHead>
                                            <MDBTableBody>
                                                {
                                                    this.state.buyers.map((e) => (
                                                        <tr key={e.id} style={{width: '100%'}}>
                                                            <td style={{paddingLeft: '10px', width: '30%'}}>
                                                                <a>{e.company_name}</a>
                                                            </td>
                                                            <td style={{textAlign: 'left', width: '70%'}}>
                                                                <a>{e.name}</a>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </MDBTableBody>
                                        </MDBTable>
                                    </div>
                                }
                                {
                                    (this.state.orgData.reseller) &&
                                    <div>
                                        <MDBTable responsive small>
                                            <MDBTableHead style={{backgroundColor: '#EEEEEE'}}>
                                                <tr style={{color: '#212529'}}>
                                                    <th colSpan={2}
                                                        style={{textAlign: 'left', paddingLeft: '10px'}}>メーカーU
                                                    </th>
                                                </tr>
                                            </MDBTableHead>
                                            <MDBTableBody>
                                                {
                                                    this.state.sellers.map((e) => (
                                                        <tr key={e.id} style={{width: '100%'}}>
                                                            <td style={{paddingLeft: '10px', width: '30%'}}>
                                                                <a>{e.company_name}</a>
                                                            </td>
                                                            <td style={{textAlign: 'left', width: '70%'}}>
                                                                <a>{e.name}</a>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </MDBTableBody>
                                        </MDBTable>
                                    </div>
                                }
                            </MDBCol>
                        </MDBRow>
                        <div style={{flexDirection: 'row', justifyContent: 'center', display: 'flex'}}>
                            <MDBBtn onClick={() => this.props.cProps.history.push('/orgList')}>一覧に戻る</MDBBtn>
                        </div>
                    </MDBContainer>
                }
            </>
        )
    }
}

export default PreviewOrg;
